import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
// import {
//     formatterTime
// } from '@/util/util'
import {
    formatterDateToUTC,
    parseStatus
} from "@/util/util";
import {
    baseUrl
} from '@/config/env';


export const serviceItemOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: '200',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "服务类目名称",
            prop: "superiorName",
            type: 'select',
            span: 13,
            placeholder: '请选择客户端类型',
            // valueDefault:"JOINS_ENGINEER",
            dicData: DIC.TAGS_CLIENT_TYPE,
            formsolt: true,
            rules: [{
                required: true,
                trigger: "blur",
                message: "请选择客户端类型"
            }],
        },
        {
            label: "服务项目名称",
            dicData: DIC.TAGS_CLIENT_TYPE,
            prop: "name",
            type: 'select',
            span: 13,
            rules: [{
                required: true,
                trigger: "blur",
                message: "请输入标签名称"
            }],
        },
        {
            label: "预约渠道",
            prop: "channel",
            type: 'select',
            dicData: DIC.SERVICEITEM_TYPE,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, value, label, column) {
                if (row.channel) {
                    let list = row.channel.split(',');
                    var result = "";
                    var index = 0;
                    for (let i of list) {
                        result += parseStatus(DIC.SERVICEITEM_TYPE, i);
                        if (index < list.length - 1) {
                            result += ',';
                        }
                        index++;
                    }
                    // return result;
                    return result
                }
            }
        },
        {
            label: "预约渠道名称",
            prop: "clientType",
            type: 'select',
            search: true,
            hide: true,
            dicData: DIC.SERVICEITEM_TYPE
        },
        {
            label: "创建时间",
            prop: "createTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "创建人",
            prop: "createBy",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false,
            width: "110"
        },
    ]
};